










































import {
  defineComponent,
  onMounted,
  reactive,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import _ from 'lodash';
import { useFormat, useRouter } from '@ideavivat/vivat-2';

import {
  getPurchaseRequests,
} from '@/api';
import { PurchaseRequest } from '@/types/purchase-request';
import { PaginatorInfo, paginatorInfo } from '@/types';
import usePurchaseRequest from '@/use/usePurchaseRequest';

import StickyFooterActionBar from '@/components/StickyFooterActionBar.vue';

const CreateIndex = defineComponent({
  components: {
    StickyFooterActionBar,
  },
  setup() {
    const { router } = useRouter();
    const toDate = (date: string): string => useFormat.date(date).displayFullThaiDate();
    const { typeTranslate, classMap } = usePurchaseRequest();
    const form = reactive({
      detail: '',
      amount: '',
      unit: '',
      date: '',
    });

    const purchaseRequests: Ref<PurchaseRequest[]> = ref([]);
    const purchaseRequestPage = ref(1);
    const purchaseRequestPaginatorInfo: Ref<PaginatorInfo> = ref(paginatorInfo);
    const filter = reactive({
      code: '',
      pendingSearch: false,
    });

    async function getPurchaseRequestsData() {
      const { data: result, ...pagination } = (await getPurchaseRequests({
        filterCode: filter.code !== '' ? filter.code : undefined,
        orderBy: [{ field: 'created_at', order: 'DESC' }],
        'page[number]': purchaseRequestPage.value,
        'page[size]': 15,
        approved: true,
        status: 'PENDING',
      })).data;

      const camelPagination = {
        from: pagination.from,
        to: pagination.to,
        lastPage: pagination.last_page,
        total: pagination.total,
        currentPage: pagination.current_page,
        perPage: pagination.per_page,
      };

      if (filter.pendingSearch || purchaseRequestPaginatorInfo.value.currentPage === camelPagination.currentPage) {
        purchaseRequests.value = [];
        purchaseRequests.value = result;
        purchaseRequestPage.value = 1;
        filter.pendingSearch = false;
      } else purchaseRequests.value = [...purchaseRequests.value, ...result, ...result];
      purchaseRequestPaginatorInfo.value = camelPagination;
    }
    const pendingSearchAction = _.debounce(async () => {
      await getPurchaseRequestsData();
    }, 500);

    onMounted(async () => {
      await getPurchaseRequestsData();
    });

    function scrollPurchaseRequestsAreaHandler(visible: any) {
      if (purchaseRequestPaginatorInfo.value.lastPage > purchaseRequestPage.value && visible) {
        purchaseRequestPage.value += 1;
      }
    }
    watch(() => purchaseRequestPage.value, async (newVal, oldVal) => {
      if (newVal !== oldVal) await getPurchaseRequestsData();
    });

    return {
      toDate,
      typeTranslate,
      classMap,
      getPurchaseRequests,
      filter,
      pendingSearchAction,
      scrollPurchaseRequestsAreaHandler,

      purchaseRequests,
      form,
    };
  },
});

export default CreateIndex;
